// Unpublished Work © 2022-2024 Deere & Company.

export const JOB = 'job';
export const USER = 'user';
export const JOBS = 'jobs';
export const NEW = 'new';
export const FROM_TEMPLATE = 'fromTemplate';
export const NEW_WORKBOARD = 'NEW_WORKBOARD';
export const NEW_WORKBOARD_TEMPLATE = 'NEW_WORKBOARD_TEMPLATE';
export const NEW_WORKBOARD_FROM_TEMPLATE = 'NEW_WORKBOARD_FROM_TEMPLATE';
export const EXISTING_WORKBOARD = 'EXISTING_WORKBOARD';
export const EXISTING_WORKBOARD_TEMPLATE = 'EXISTING_WORKBOARD_TEMPLATE';
export const WORKBOARD_TYPES = [NEW_WORKBOARD, EXISTING_WORKBOARD, NEW_WORKBOARD_FROM_TEMPLATE];
